module.exports = __webpack_public_path__ + "media/favicon/favicon-32x32-72aa63ee.png";